import Vue from 'vue'
import VueI18n from 'vue-i18n'
import getBrowserLocales from '@/util/i18n/get-browser-locale'
import { supportedLocalesInclude } from './util/i18n/supported-locales'

Vue.use(VueI18n)

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

// First language in the browser's preference list that the site supports;
// visitors who read neither German nor English get English.
export function getStartingLocale() {
  const browserLocale = getBrowserLocales({ countryCodeOnly: true })
    .find(supportedLocalesInclude)

  return browserLocale || 'en'
}

export default new VueI18n({
  locale: getStartingLocale(),
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'de',
  messages: loadLocaleMessages()
})
